export const ROLE_FUNCTION_IDS: Record<string, string> = {
  "Accounting": "1",
  "Administrative": "2",
  "Arts and Design": "3",
  "Business Development": "4",
  "Community and Social Services": "5",
  "Consulting": "6",
  "Education": "7",
  "Engineering": "8",
  "Entrepreneurship": "9",
  "Finance": "10",
  "Healthcare Services": "11",
  "Human Resources": "12",
  "Information Technology": "13",
  "Legal": "14",
  "Marketing": "15",
  "Media and Communication": "16",
  "Military and Protective Services": "17",
  "Operations": "18",
  "Product Management": "19",
  "Program and Project Management": "20",
  "Purchasing": "21",
  "Quality Assurance": "22",
  "Real Estate": "23",
  "Research": "24",
  "Sales": "25",
  "Customer Success and Support": "26",
};

export const getRoleFunctionId = (name: string): string | undefined => {
  const id = ROLE_FUNCTION_IDS[name.trim()];
  if (!id) {
    console.log(`ℹ️  No LinkedIn ID found for role function: "${name}" - using text search fallback`);
  }
  return id;
};

export const SENIORITY_LEVEL_IDS: Record<string, string> = {
  "Owner / Partner": "320",
  "CXO": "310",
  "Vice President": "300",
  "Director": "220",
  "Experienced Manager": "210",
  "Entry Level Manager": "200",
  "Strategic": "130",
  "Senior": "120",
  "Entry Level": "110",
  "In Training": "100",
};

export const getSeniorityLevelId = (label: string): string | undefined => {
  const id = SENIORITY_LEVEL_IDS[label.trim()];
  if (!id) {
    console.log(`ℹ️  No LinkedIn ID found for seniority level: "${label}" - using text search fallback`);
  }
  return id;
};
